import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmSlack = (props) => /* @__PURE__ */ _jsxs("svg", {
	height: "16px",
	style: { enableBackground: "new 0 0 16 16" },
	viewBox: "0 0 512 512",
	width: "16px",
	xmlSpace: "preserve",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "_x33_06-slack",
		children: /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M122.643,316.682c0,26.596-21.727,48.323-48.321,48.323c-26.593,0-48.319-21.728-48.319-48.323    c0-26.592,21.727-48.318,48.319-48.318h48.321V316.682z",
				style: { fill: "#E01E5A" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M146.996,316.682c0-26.592,21.728-48.318,48.321-48.318c26.593,0,48.32,21.727,48.32,48.318V437.68    c0,26.592-21.728,48.319-48.32,48.319c-26.594,0-48.321-21.728-48.321-48.319V316.682z",
				style: { fill: "#E01E5A" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M195.317,122.643c-26.594,0-48.321-21.728-48.321-48.321c0-26.593,21.728-48.32,48.321-48.32    c26.593,0,48.32,21.728,48.32,48.32v48.321H195.317L195.317,122.643z",
				style: { fill: "#36C5F0" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M195.317,146.997c26.593,0,48.32,21.727,48.32,48.321c0,26.593-21.728,48.318-48.32,48.318H74.321    c-26.593,0-48.319-21.726-48.319-48.318c0-26.595,21.727-48.321,48.319-48.321H195.317L195.317,146.997z",
				style: { fill: "#36C5F0" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M389.359,195.318c0-26.595,21.725-48.321,48.32-48.321c26.593,0,48.318,21.727,48.318,48.321    c0,26.593-21.726,48.318-48.318,48.318h-48.32V195.318L389.359,195.318z",
				style: { fill: "#2EB67D" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M365.004,195.318c0,26.593-21.728,48.318-48.321,48.318c-26.593,0-48.32-21.726-48.32-48.318    V74.321c0-26.593,21.728-48.32,48.32-48.32c26.594,0,48.321,21.728,48.321,48.32V195.318L365.004,195.318z",
				style: { fill: "#2EB67D" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M316.683,389.358c26.594,0,48.321,21.727,48.321,48.321c0,26.592-21.728,48.319-48.321,48.319    c-26.593,0-48.32-21.728-48.32-48.319v-48.321H316.683z",
				style: { fill: "#ECB22E" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M316.683,365.005c-26.593,0-48.32-21.728-48.32-48.323c0-26.592,21.728-48.318,48.32-48.318H437.68    c26.593,0,48.318,21.727,48.318,48.318c0,26.596-21.726,48.323-48.318,48.323H316.683z",
				style: { fill: "#ECB22E" }
			})
		] })
	}), /* @__PURE__ */ _jsx("g", { id: "Layer_1" })]
});
export default SvgSmSlack;
